import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { useT } from '../../i18n/useT';
import logoText from '../../assets/logo_text.png';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { lang, switchLang } = useLanguage();
  const t = useT();

  const NAV_LINKS = [
    { to: '/features', label: t.nav.features },
    { to: '/faq', label: t.nav.faq },
    { to: '/support', label: t.nav.support },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`} role="banner">
      <div className="navbar__container container-wide">
        <Link to="/" className="navbar__logo" aria-label="Docudi – Home">
          <img src={logoText} alt="Docudi" className="navbar__logo-img" />
        </Link>

        <nav className="navbar__nav" aria-label="Main navigation">
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `navbar__link ${isActive ? 'navbar__link--active' : ''}`}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="navbar__actions">
          <div className="lang-switcher" role="group" aria-label="Language">
            <button
              className={`lang-switcher__btn${lang === 'en' ? ' lang-switcher__btn--active' : ''}`}
              onClick={() => switchLang('en')}
              aria-pressed={lang === 'en'}
            >EN</button>
            <span className="lang-switcher__sep" aria-hidden="true">|</span>
            <button
              className={`lang-switcher__btn${lang === 'de' ? ' lang-switcher__btn--active' : ''}`}
              onClick={() => switchLang('de')}
              aria-pressed={lang === 'de'}
            >DE</button>
          </div>
          <a href="https://app.docudi.ployify.com/login" className="btn btn-ghost btn-sm" target="_blank" rel="noopener noreferrer">{t.nav.signIn}</a>
          <a href="https://app.docudi.ployify.com/register" className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer">{t.nav.getStarted}</a>
        </div>

        <button
          className={`navbar__mobile-toggle ${mobileOpen ? 'is-open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-expanded={mobileOpen}
          aria-label="Toggle navigation menu"
        >
          <span /><span /><span />
        </button>
      </div>

      <div
        className={`navbar__mobile ${mobileOpen ? 'navbar__mobile--open' : ''}`}
        aria-hidden={!mobileOpen}
      >
        <nav aria-label="Mobile navigation">
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `navbar__mobile-link ${isActive ? 'navbar__mobile-link--active' : ''}`}
            >
              {label}
            </NavLink>
          ))}
          <div className="navbar__mobile-lang">
            <button
              className={`lang-switcher__btn${lang === 'en' ? ' lang-switcher__btn--active' : ''}`}
              onClick={() => switchLang('en')}
              aria-pressed={lang === 'en'}
            >EN</button>
            <span className="lang-switcher__sep" aria-hidden="true">|</span>
            <button
              className={`lang-switcher__btn${lang === 'de' ? ' lang-switcher__btn--active' : ''}`}
              onClick={() => switchLang('de')}
              aria-pressed={lang === 'de'}
            >DE</button>
          </div>
          <div className="navbar__mobile-actions">
            <a href="https://app.docudi.ployify.com/login" className="btn btn-ghost" target="_blank" rel="noopener noreferrer">{t.nav.signIn}</a>
            <a href="https://app.docudi.ployify.com/register" className="btn btn-primary" target="_blank" rel="noopener noreferrer">{t.nav.getStarted}</a>
          </div>
        </nav>
      </div>
    </header>
  );
}
